import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";
import { useDispatch, useSelector } from 'react-redux';
import { GetSmsCampaignShortcutsView } from '../Features/SmscampaignShortcuts/Smscampaignshortcutview';
import { RootState, AppDispatch } from '../Appstore/store';
import { formatDate } from '../helper';
import { setIsLoading } from '../Features/loadingSlice';

interface SmsCampaignShortcuts {
    id?: number;
    sms_campaign_id?: number;
    code: string;
    message: string;
    createdAt?: string;
    updatedAt?: string;
}

function Viewsmscampaignshortcuts() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { id }: any = useParams();

    const { error, smscampaignshortcutsdataview, loading } = useSelector((state: RootState) => state.smscampaignshortcutsview);
    const record: SmsCampaignShortcuts | any = smscampaignshortcutsdataview.find(gateway => gateway.id === Number(id));

    useEffect(() => {
        if (id) {
            dispatch(setIsLoading(true));
            dispatch(GetSmsCampaignShortcutsView(id))
                .unwrap()
                .catch(err => {
                    console.error('Error fetching agent monitor:', err);
                })
                .finally(() => {
                    setTimeout(() => dispatch(setIsLoading(false)), 500);
                });
        }
    }, [id, dispatch]);

    if (!record) {
        return <div>No record found</div>;
    }
    const navigatetobackpage = () => {
        navigate(-1);
    };

    return (
        <>
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="card mt-4 shadow-sm border rounded">
                                <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                                    <h2 className="w-100 mb-md-0 fs-3">View SMS Campaign List Shortcuts</h2>
                                    <Link to={''} className='text-decoration-none'>
                                        <button onClick={navigatetobackpage} className='btn btn-info text-white d-flex align-items-center fw-semibold'>
                                            <IoMdArrowRoundBack /> Back
                                        </button>
                                    </Link>
                                </div>

                                <div className="card-body px-0 py-0">
                                    <div className='table-responsive'>
                                        <table className="table mb-0 table-bordered">
                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan={7} height={100}>
                                                            <div className="text-center" >
                                                                <div className="loader"></div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : !smscampaignshortcutsdataview || smscampaignshortcutsdataview.length == 0 ? (
                                                    <tr>
                                                        <td colSpan={7} height={50}>
                                                            <div className="text-center">
                                                                <p className='mb-0 fs-5 fw-semibold'>No data found</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Code</th>
                                                            <td className='p-3'>{record?.code}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Message</th>
                                                            <td className='p-3'>{record?.message}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Created At</th>
                                                            <td className='p-3'>{formatDate(record?.createdAt)}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Updated At</th>
                                                            <td className='p-3'>{formatDate(record?.updatedAt)}</td>
                                                        </tr>
                                                    </>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}

export default Viewsmscampaignshortcuts;
